export default __webpack_public_path__ + "static/media/project4.0832e7a1.png";